// extracted by mini-css-extract-plugin
module.exports = {"close":"close-3k9H4","number":"number-2syV5"};